var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });

// src/index.ts
import isPlainObject from "lodash.isplainobject";
var isRecordType = /* @__PURE__ */ __name((value) => isPlainObject(value), "isRecordType");
var isMatchType = /* @__PURE__ */ __name((value) => {
  return isRecordType(value) && Array.isArray(value.meta) && value.meta.every((meta) => isPlainObject(meta));
}, "isMatchType");
var isMemberOfEnum = /* @__PURE__ */ __name((token, e) => Object.values(e).includes(token), "isMemberOfEnum");
export {
  isMatchType,
  isMemberOfEnum,
  isRecordType
};
/*! For license information please see index.mjs.LEGAL.txt */
//# sourceMappingURL=index.mjs.map
